import Vue from 'vue'
import VueRouter from 'vue-router'

import Store from '@/utils/Store'

import Dashboard from '@/views/Dashboard'
import Login from '@/views/Login'
import Session from '../model/Session'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/tokens',
        name: 'Tokens',
        component: () => import('@/views/Tokens.vue'),
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/domains',
        name: 'Domains',
        component: () => import('@/views/Domains.vue'),
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/imprint',
        name: 'Imprint',
        component: () => import('@/views/Imprint.vue')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('@/views/Privacy.vue')
    }
]

const router = new VueRouter({
    routes
})

router.isLoggedIn = function() {
    return Store.state.session instanceof Session
}

router.beforeEach((to, _from, next) => {
    if (typeof to.meta.requireLogin === 'boolean' && to.meta.requireLogin && !router.isLoggedIn()) {
        next('/login')
        return
    }
    next()
})

router.afterEach((to, _from) => {
    if (typeof to.meta.requireLogin === 'boolean' && to.meta.requireLogin && !router.isLoggedIn()) {
        router.push('/login')
    }
})

export default router
